import React, { useState } from 'react';

import { Helmet } from 'react-helmet';

import { Box, Container } from '@mui/material';

import PageSubheader from '../../Common/Elements/PageSubheader';
import { withTenant } from '../../hoc';
import MyVouchersTesterContainer from '../MyVouchersTester/MyVouchersTesterContainer';
import usePromoTesterUrl from '../hooks/usePromoTesterUrl';

import MarketingRouterEvaluator from './MarketingRouterEvaluator';
import PromoTester from './PromoTester';

interface Props {
  tenant: App.Tenant;
}

function PromoTesterContainer({ tenant }: Props) {
  const [orderCustomerUserId, setOrderCustomerUserId] = useState<string | undefined>();
  const { urlState, updateUrlState } = usePromoTesterUrl({
    brand: tenant.brand,
  });

  return (
    <Container>
      <Helmet>
        <title>Promo Tester</title>
      </Helmet>
      <PageSubheader title="Test promos against existing orders" />
      <Box mt={2}>
        <PromoTester
          initOrderId={urlState.orderId}
          initCodeName={urlState.codeName}
          initVoucherIdsRaw={urlState.voucherIds}
          initApplyWithOrignalUserAccount={urlState.applyWithOrignalUserAccount}
          initIgnoreLuxPlusPricing={urlState.ignoreLuxPlusPricing ?? true}
          tenant={tenant}
          onOrderCustomerUserIdChange={setOrderCustomerUserId}
          // URL management props
          urlState={urlState}
          updateUrlState={updateUrlState}
        />
      </Box>
      <Box mt={2}>
        <MyVouchersTesterContainer tenant={tenant} orderCustomerUserId={orderCustomerUserId} />
      </Box>
      <Box mt={2}>
        <MarketingRouterEvaluator tenant={tenant} />
      </Box>
    </Container>
  );
}

export default withTenant(PromoTesterContainer);
